import { Link } from "react-router-dom";
import { Image } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import CloseButton from "./CloseButton/CloseButton";
import MainHeader from "./MainHeader/MainHeader";
import { Row } from "reactstrap";
import { useAppSelector } from "../../ReduxToolkit/Hooks";

const Header = () => {
  const { sidebarClose } = useAppSelector((state) => state.layout);
  return (
    <div className={`page-header ${sidebarClose ? "close_icon" : "" }`}>
      <Row className="header-wrapper m-0">
        <div className="header-logo-wrapper col-auto p-0">
          <div className="logo-wrapper">
            <Link to={`${process.env.PUBLIC_URL}/dashboard/ecommerce`}>
              <Image className="img-fluid for-light" src={dynamicImage("logo/logo-1.png")} alt="logo"/>
              <Image className="img-fluid for-dark" src={dynamicImage("logo/logo-dark.png")} alt="logo"/>
            </Link> 
          </div>
          <CloseButton />
        </div>
        <MainHeader />
      </Row>
    </div>
  );
};

export default Header;
